
import { NgModule, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { LocationStrategy, HashLocationStrategy, registerLocaleData, getLocaleNumberSymbol } from '@angular/common';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GestureConfig } from '@angular/material';

// import ngx-translate and the http loader
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient, HttpClientModule} from '@angular/common/http';

import localeFr from '@angular/common/locales/fr';
import localeNl from '@angular/common/locales/nl';
import localeDe from '@angular/common/locales/de';
import localeLu from '@angular/common/locales/lu';
import localePt from '@angular/common/locales/pt';
import { MsalModule } from '@azure/msal-angular';
import { OAuthSettings } from '../oauth';

registerLocaleData(localeFr, 'fr');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeLu, 'pt');
registerLocaleData(localePt, 'lu');


@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        CoreModule,
        BrowserAnimationsModule,
        BrowserModule,
        HttpClientModule,
        MsalModule.forRoot({
            auth: {
                clientId: OAuthSettings.appId
            }
        }, {
            popUp: true,
            consentScopes: ['https://graph.microsoft.com/User.ReadWrite']
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    exports: [],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    providers: [
        {provide: LocationStrategy, useClass: HashLocationStrategy},
        {provide: LOCALE_ID, useValue: 'fr'},
        { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
